<template>
  <button
    :id="id"
    class="tw-inline-flex tw-items-center tw-rounded-full tw-transition-colors focus:tw-outline-none focus-visible:tw-ring focus-visible:tw-ring-offset-2 disabled:tw-cursor-not-allowed"
    :class="[
      checkedValue ? colors[color].wrapper.on : 'tw-bg-neutral-200',
      sizes[size].wrapper,
      colors[color].wrapper.base,
    ]"
    :disabled="isDisabled"
    @click="handleChange"
    :test_id="$attrs.test_id"
  >
    <span
      class="tw-rounded-full tw-shadow tw-transition-transform"
      :class="[
        checkedValue ? sizes[size].translate.on : sizes[size].translate.off,
        isDisabled ? 'tw-bg-neutral-50' : 'tw-bg-white',
        sizes[size].dot,
      ]"
    />
  </button>
</template>

<script setup>
import { getUniqueId } from '@/shared/utils/uniqueId.js'
import { computed } from 'vue'

const props = defineProps({
  modelValue: {
    type: [Array, Boolean],
    default: false,
  },
  value: {
    type: String,
    default: '',
  },
  isDisabled: {
    type: Boolean,
    default: false,
  },
  size: {
    type: String,
    default: 'regular',
  },
  color: {
    type: String,
    default: 'success',
  },
})

const emit = defineEmits(['update:checked', 'update:modelValue'])

const id = `growthmentor-toggle-${getUniqueId()}`

const checkedValue = computed(() => {
  return Array.isArray(props.modelValue)
    ? props.modelValue.includes(props.value)
    : props.modelValue
})

const handleChange = () => {
  if (Array.isArray(props.modelValue)) {
    const toggleArray = [...props.modelValue]
    if (toggleArray.includes(props.value)) {
      toggleArray.splice(toggleArray.indexOf(props.value), 1)
    } else {
      toggleArray.push(props.value)
      emit('update:checked', props.value)
    }
    emit('update:modelValue', toggleArray)
  } else {
    const newValue = !props.modelValue
    if (newValue) emit('update:checked', props.value)
    emit('update:modelValue', newValue)
  }
}

const sizes = {
  small: {
    wrapper: 'tw-h-6 tw-w-12',
    dot: 'tw-h-4 tw-w-4',
    translate: {
      on: 'tw-translate-x-7',
      off: 'tw-translate-x-1',
    },
  },
  regular: {
    wrapper: 'tw-h-8 tw-w-16',
    dot: 'tw-h-6 tw-w-6',
    translate: {
      on: 'tw-translate-x-9',
      off: 'tw-translate-x-1',
    },
  },
}

const colors = {
  success: {
    wrapper: {
      base: 'focus-visible:tw-ring-success-500',
      on: 'tw-bg-success-500 disabled:tw-bg-success-300',
    },
  },
  secondary: {
    wrapper: {
      base: 'focus-visible:tw-ring-secondary-500',
      on: 'tw-bg-secondary-500 disabled:tw-bg-secondary-300',
    },
  },
}
</script>
